export const isMobileDevice = (userAgent) => {
    if (!userAgent)
        return false; // Handle null/undefined
    const mobileRegex = /Mobi|Android|iPhone|iPod|iPad/i; // Added iPad here
    // Removed broad Macintosh check: const iPadRegex = /iPad|Macintosh/i;
    if (mobileRegex.test(userAgent)) {
        return true;
    }
    // Keep this check if needed for specific iPad Pro / Request Desktop Site cases
    // Requires careful UA analysis
    if (/Macintosh/i.test(userAgent) && /Mobile/i.test(userAgent)) {
        return true;
    }
    return false;
};
export const generateUniqueId = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};
